import {create} from 'zustand';
import {IServiceRequest} from '../../../../../shared/types/serviceRequest.types';

interface RequestMapStore {
  selectedContractId: number | null;
  isLoading: boolean;
  requests: IServiceRequest[];

  setSelectedContractId: (contractId: number | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  setRequests: (requests: IServiceRequest[]) => void;
}

export const useRequestMapStore = create<RequestMapStore>((set) => ({
  selectedContractId: null,
  isLoading: false,
  requests: [],

  setSelectedContractId: (contractId) => set({selectedContractId: contractId}),
  setIsLoading: (isLoading) => set({isLoading}),
  setRequests: (requests) => set({requests, isLoading: false}),
}));
